import type { JwtTokenPayload } from 'shared/jwt'

import type { TRoutes } from '~/types/routes'

export const getPostAuthRedirectRoute = (subscriptionStatus?: JwtTokenPayload['subscriptionStatus']): TRoutes =>
  subscriptionStatus === 'ACTIVE' ? '/list' : '/subscription'
